module.exports = __webpack_public_path__ + "img/horizontal_4_7_5012.399c7885.png";